import { render } from "./AboutView.vue?vue&type=template&id=587f8404&scoped=true"
const script = {}

import "./AboutView.vue?vue&type=style&index=0&id=587f8404&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587f8404"]])

export default __exports__